import { render, staticRenderFns } from "./Menu_1_1_1.vue?vue&type=template&id=4bd4f54f&scoped=true&"
import script from "./Menu_1_1_1.vue?vue&type=script&lang=js&"
export * from "./Menu_1_1_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd4f54f",
  null
  
)

export default component.exports